module.exports = __webpack_public_path__ + "img/26.af81dee2.jpg";